export default __webpack_public_path__ + "static/media/abobora_butternut.ff091ef3.jpg";